// extracted by mini-css-extract-plugin
module.exports = {"title":"BlogPageTitle-module--title--u480u"};